import Button from '../common/Button';

function ServiceHero({ service }) {
  const { hero, snapshot } = service;

  return (
    <section className="service-hero">
      <div className="container service-hero__grid">
        <div className="service-hero__copy">
          <p className="eyebrow">{hero.label}</p>
          <h1>{hero.title}</h1>
          <h2>{hero.headline}</h2>
          <p>{hero.description}</p>

          <div className="service-hero__actions">
            <Button href={hero.primaryCta.href}>{hero.primaryCta.label}</Button>
            <Button to={hero.secondaryCta.to} variant="secondary">
              {hero.secondaryCta.label}
            </Button>
          </div>
          <a
            className="service-hero__website"
            href={hero.websiteUrl}
            rel="noreferrer"
            target="_blank"
          >
            {hero.websiteDisplay}
          </a>
        </div>

        <div className="service-preview" aria-label={`${hero.title} service preview`}>
          <div className="service-preview__image">
            <img src={hero.previewImage} alt={`${hero.title} service preview`} />
          </div>
          <div className="service-preview__chips">
            {snapshot.slice(0, 4).map((item) => (
              <span key={item}>{item}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ServiceHero;
